.c7{background:var(--palette-white);}